import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "tw-text-caption tw-h-full tw-w-full tw-py-1 tw-px-3 tw-text-white"
};
import { ref, reactive } from 'vue';
import { useFloating, offset, flip, shift, autoUpdate, size } from '@floating-ui/vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Tooltip',
    props: {
        /** Tooltip text */
        text: { type: String, default: undefined },
        /** Preferred position of the tooltip around the target element.
         * If the tooltip does not fit at the desired position,
         * it will figure out the next best alternative location*/
        position: {
            type: String,
            default: 'bottom'
        },
        /** Maximum width of the tooltip. Any CSS size is accepted. */
        maxWidth: {
            type: String,
            default: undefined
        },
        /** Maximum height of the tooltip. Any CSS size is accepted. */
        maxHeight: {
            type: String,
            default: undefined
        },
        /** Fixed width of the tooltip. Any CSS size is accepted. */
        width: {
            type: String,
            default: undefined
        },
        /** Fixed height of the tooltip. Any CSS size is accepted. */
        height: {
            type: String,
            default: undefined
        }
    },
    setup(__props) {
        const props = __props;
        const tooltipContainer = ref();
        const tooltip = ref();
        const data = reactive({ tooltip: null });
        const createTooltip = function () {
            data.tooltip = useFloating(tooltipContainer, tooltip, {
                placement: props.position,
                middleware: [
                    // Tooltip is located N px from the target element.
                    offset(8),
                    // If tooltip cannot fit in the prefered position, the next best position is chosen.
                    flip(),
                    // The tooltip will not be closer than N amount of pixels from the window edge.
                    shift({
                        padding: 16
                    }),
                    size({
                        apply({ availableWidth, availableHeight, elements }) {
                            Object.assign(elements.floating.style, {
                                // Use max size properties if given. Otherwise use all available space.
                                maxWidth: props.maxWidth ?? `${availableWidth}px`,
                                maxHeight: props.maxHeight ?? `${availableHeight}px`
                            });
                        }
                    })
                ],
                whileElementsMounted: autoUpdate
            });
        };
        const dismissTooltip = function () {
            data.tooltip = null;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    ref_key: "tooltipContainer",
                    ref: tooltipContainer,
                    class: "tw-h-fit tw-w-fit",
                    "data-test-id": "tooltipContainer",
                    onMouseenter: createTooltip,
                    onMouseleave: dismissTooltip
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 544),
                (data.tooltip !== null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref_key: "tooltip",
                        ref: tooltip,
                        "data-test-id": "tooltip",
                        style: _normalizeStyle({
                            position: data.tooltip.strategy,
                            top: `${data.tooltip.y ?? 0}px`,
                            left: `${data.tooltip.x ?? 0}px`,
                            height: props.height,
                            width: props.width
                        }),
                        class: "tw-z-tooltip tw-box-border tw-overflow-hidden tw-rounded-xs tw-bg-secondary-medium"
                    }, [
                        (__props.text)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.text), 1))
                            : _createCommentVNode("", true),
                        _renderSlot(_ctx.$slots, "tooltip-content")
                    ], 4))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
